import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CtaButtonProps {
  label?: string;
  subline?: string;
  variant?: 'primary' | 'gold';
  pulse?: boolean;
  className?: string;
}
export function CtaButton({
  label = 'QUIERO LA RUTA FERTILIDAD MASCULINA',
  subline = 'Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días',
  variant = 'primary',
  pulse = false,
  className = ''
}: CtaButtonProps) {
  const base = variant === 'gold' ? 'bg-gold-500 hover:bg-gold-400 text-navy-950 shadow-[0_10px_30px_-8px_rgba(201,162,39,0.6)]' : 'bg-violet-600 hover:bg-violet-500 text-white shadow-cta';
  return <div className={`w-full ${className}`} data-id="element-85" data-mp="vddcnknn4pd9">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-colors sm:text-lg sm:py-5 ${base} ${pulse ? 'animate-pulse-cta' : ''}`} data-id="element-86" data-mp="19ajsp7gzc9ys">
        <span data-id="element-87" data-mp="3a0u6y5bnzzrf">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-88" data-mp="3ey40nx636xl2" />
      </a>
      {subline && <p className="mt-3 text-center text-[11px] font-medium leading-relaxed text-navy-800/70 sm:text-sm" data-id="element-89" data-mp="3juksb1chvu2w">
          {subline}
        </p>}
    </div>;
}
interface TransformCtaProps {
  headline: string;
  label?: string;
  tone?: 'light' | 'dark';
}
export function TransformCta({
  headline,
  label,
  tone = 'light'
}: TransformCtaProps) {
  return <div className={`mx-auto mt-10 w-full max-w-xl rounded-3xl border p-5 sm:p-6 ${tone === 'dark' ? 'border-white/15 bg-white/5' : 'border-navy-800/10 bg-white shadow-card'}`} data-id="element-90" data-mp="6gpsc0gtsh9u">
      <p className={`mb-4 text-center font-display text-lg font-bold leading-snug sm:text-xl ${tone === 'dark' ? 'text-white' : 'text-navy-900'}`} data-id="element-91" data-mp="ge46tuj6uvzi">
        {headline}
      </p>
      <CtaButton label={label ?? 'QUIERO MI RUTA CLÍNICA AHORA'} subline="" data-id="element-92" data-mp="3hwjdo3g5tzcf" />
      <p className={`mt-3 text-center text-[11px] font-medium sm:text-xs ${tone === 'dark' ? 'text-white/60' : 'text-navy-800/60'}`} data-id="element-93" data-mp="j790bcw1tf9">
        Pago único · Acceso de por vida · Garantía de 7 días
      </p>
    </div>;
}